<template>
    <div>
        <div v-if="!load">
            <!--====== PAGE TITLE PART START ======-->
            <section class="page-title-area bg_cover"
                style="background-position: center; margin-top: 0; padding: 100px 0; max-height: 600px"
                :style="[project.image != null ? 'background-image: url(' + project.image.src + ')' : 'background: url(assets/images/detail.jpg) bottom center']">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-12">
                            <div class="page-title-content">
                                <!-- <h3 class="title">Détail</h3> -->
                            </div>
                            <img :src="project.logo.src" alt="Logo entreprise" class="img-fluid"
                                style="max-height: 10%">
                        </div>
                    </div>
                </div>
            </section>
            <!--====== PAGE TITLE PART ENDS ======-->

            <!--====== PROJECT DETAILS PART START ======-->
            <section class="project-details-area pt-120 pb-190">
                <div class="container">
                    <div class="row">
                        <div class="col-lg-7">
                            <div class="project-details-thumb">
                                <div v-if="project.video != null">
                                    <iframe width="670" height="537"
                                        :src="'https://www.youtube.com/embed/' + project.video"
                                        title="YouTube video player" frameborder="0"
                                        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
                                        allowfullscreen></iframe>
                                </div>
                                <div v-else>
                                    <img @click="showImg(project.image_presentation.src)" :src="project.image_presentation.src" alt="img"
                                        draggable="false" width="670" height="537">
                                </div>
                                <div class="icon">
                                    <!-- <i v-if="project.video == null" @click="like(project.id)" class="fa fa-heart"
                                        style="cursor: pointer;"></i> -->
                                </div>
                            </div>
                            <h4 class="mt-3">
                                <span style="text-decoration: underline; color: #ef9b05;">CONDITION DE LA CAMPAGNE:</span> {{ project.campagne_condition }}
                            </h4>
                            <h4 class="mt-3">
                                <span style="text-decoration: underline; color: #ef9b05;">TYPE DE CAMPAGNE:</span> {{ project.campagne_type }}
                            </h4>
                        </div>
                        <div class="col-lg-5">
                            <div class="project-details-content">
                                <h3 class="title">{{ project.name }}</h3>
                                <p class="mb-3">{{ project.project_summary }}</p>
                                <div class="project-details-item">
                                    <div v-if="project.campagne_type == 'Vote'" class="item text-center">
                                        <h5 class="title">{{ project.like }}</h5>
                                        <span>Vote</span>
                                    </div>
                                    <div v-else class="item text-center">
                                        <h5 class="title">{{ project.contribution.toLocaleString("en-US") }}</h5>
                                        <span>Collecté</span>
                                    </div>
                                    <div v-if="project.campagne_type != 'Vote'" class="item text-center">
                                        <h5 class="title">{{
                                            project.name == 'Aukohi Chap Chap' ? 12
                                                : project.name ==
                                                    'Les latrines et les blocs sanitaires à usage scolaire' ? 8 :
                                                    project.name ==
                                                        'Lumière à Akêkoi' ? 33 :
                                                        project.name ==
                                                            "K’RINE MODE & CREATION" ? 35 :
                                                            project.name ==
                                                                'PLAYTIME' ? 20 :
                                                                project.contributeur.length
                                        }}</h5>
                                        <span>Contributeurs</span>
                                    </div>
                                    <div v-if="project.campagne_type != 'Vote'" class="item text-center">
                                        <h5 class="title">{{ project.campagn_duration }}</h5>
                                        <span>Jours restant</span>
                                    </div>
                                </div>
                                <div v-if="project.campagne_type != 'Vote'" class="projects-range">
                                    <div class="projects-range-content">
                                        <ul>
                                            <li>Progression:</li>
                                            <li>{{ parseInt((project.contribution / project.amount) * 100)}}%</li>
                                        </ul>
                                        <div class="progress" style="height: 7px;">
                                            <div class="progress-bar" role="progressbar"
                                                :style="['width:' + (project.contribution / project.amount) * 100 + '%']"
                                                aria-valuenow="25" aria-valuemin="0" :aria-valuemax="100"></div>
                                        </div>
                                    </div>
                                </div>
                                <div v-if="project.campagne_type != 'Vote'" class="projects-goal">
                                    <span>Objectif: <span>{{ parseInt(project.amount).toLocaleString("en-US") }}</span></span>
                                </div>
                                <div v-if="project.etat != 'Clôturé et réussi' && project.etat != 'Clôturé et échoué' && project.etat != 'Enregistré' && project.campagne_type != 'Vote'"
                                    class="project-btn mt-25">
                                    <button @click="checkConnect(project.slug)" class="main-btn">Je soutiens ce
                                        projet</button>
                                </div>
                                <div v-if="project.campagne_type == 'Vote' && (new Date(project.date_fin ?? '2100-12-31').getTime() - new Date().getTime() >= 0)" class="project-btn mt-25">
                                    <button @click="vote(project.id)" class="main-btn">Je vote pour ce projet</button>
                                </div>
                                <div class="project-share d-flex align-items-center">
                                    <span>Partager sur</span>
                                    <div class="sharethis-inline-share-buttons"></div>
                                </div>
                                <figure class="qrcode mt-5">
                                    <vue-qrcode
                                        :value="url"
                                        tag="svg"
                                        :options="{
                                            errorCorrectionLevel: 'Q',
                                            width: 200,
                                        }"
                                    ></vue-qrcode>
                                    <img
                                        class="qrcode__image"
                                        src="assets/images/icon.png"
                                        alt="Logo"
                                    />
                                </figure>
                                <i class="fa fa-download fa-2x mt-5" @click="downloadQrCode" aria-hidden="true"></i>
                            </div>

                        </div>
                    </div>
                </div>
            </section>
            <!--====== PROJECT DETAILS PART ENDS ======-->

            <!--====== PROJECT CONTENT PART START ======-->
            <section class="project-details-content-area pb-110">
                <div class="container">
                    <div class="row justify-content-center">
                        <div class="col-lg-7">
                            <div class="tab-btns">
                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link active" id="pills-home-tab" data-toggle="pill"
                                            href="#pills-home" role="tab" aria-controls="pills-home"
                                            aria-selected="true">Contexte et
                                            justificatif</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="pills-profile-tab" data-toggle="pill"
                                            href="#pills-profile" role="tab" aria-controls="pills-profile"
                                            aria-selected="false">Plan
                                            d’exécution</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="pills-contact-tab" data-toggle="pill"
                                            href="#pills-contact" role="tab" aria-controls="pills-contact"
                                            aria-selected="false">Budget détaillé
                                            du projet</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link" id="pills-4-tab" data-toggle="pill" href="#pills-4"
                                            role="tab" aria-controls="pills-4" aria-selected="false">Présentation de
                                            l’équipe</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-home" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div class="project-details-content-top">
                                        <p>{{ project.context }}</p>
                                        <img @click="showImg(project.context_justificatif.src)"
                                            v-if="project.context_justificatif != null"
                                            :src="project.context_justificatif.src" alt="img" draggable="false"
                                            width="600" height="300" />
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-profile" role="tabpanel"
                                    aria-labelledby="pills-profile-tab">
                                    <div class="project-details-content-top">
                                        <p>{{ project.execution_plan }}</p>
                                        <img @click="showImg(project.plan_execution.src)"
                                            v-if="project.plan_execution != null" :src="project.plan_execution.src"
                                            alt="img" draggable="false" width="600" height="300" />
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-contact" role="tabpanel"
                                    aria-labelledby="pills-contact-tab">
                                    <div class="project-details-content-top">
                                        <p>{{ project.detailed_budget }}</p>
                                        <img @click="showImg(project.budget_detaille.src)"
                                            v-if="project.budget_detaille != null" :src="project.budget_detaille.src"
                                            alt="img" draggable="false" width="600" height="300" />
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-4" role="tabpanel" aria-labelledby="pills-4-tab">
                                    <div class="project-details-content-top">
                                        <p>{{ project.description }}</p>
                                        <img @click="showImg(project.presentation_equipe.src)"
                                            v-if="project.presentation_equipe != null"
                                            :src="project.presentation_equipe.src" alt="img" draggable="false"
                                            width="600" height="300" />
                                    </div>
                                </div>
                            </div>
                            <vue-easy-lightbox :visible="visible" :imgs="img" :index="index"
                                @hide="visible = false"></vue-easy-lightbox>
                        </div>
                        <div v-if="project.contreparties.length != 0" class="col-lg-5">
                            <h4 class="pb-2">Liste des contreparties</h4> <br />
                            <div v-for="item in project.contreparties" :key="item.id" class="text-center">
                                <div @click="checkConnect(project.slug, item.id)" class="jumbotron border border-info" style="cursor: pointer;">
                                    <h5 class="text-left"><strong class="text-primary text-bold">{{ parseInt(item.montant).toLocaleString("en-US") }} FCFA</strong></h5>
                                    <img v-if="item.image != null" :src="item.image.src" width="250" height="200" class="my-1 text-center" />
                                    <h5 class="text-left my-1"><strong>{{ item.titre }}</strong></h5>
                                    <p class="text-left my-2">{{ item.description }}</p>
                                    <p class="text-left"><strong class="text-primary">Mode</strong>: {{ item.mode_acquisition }}</p>
                                    <p class="text-left my-2"><strong class="text-primary">Nombre</strong>: {{ item.nombre.toLocaleString("en-US") }}</p>
                                </div>
                            </div>
                            <div v-if="project.label != null" class="col-lg-10">
                                <figure class="text-center">
                                    <img :src="project.label.src" style="border-radius: 10%; width: 250px; height: 250px;" />
                                    <figcaption>Label du projet</figcaption>
                                </figure>
                            </div>
                        </div>
                    </div>
                    <hr>
                    <div class="row justify-content-center" style="margin-top: 150px;">
                        <div class="col-lg-8">
                            <div class="tab-btns">
                                <ul class="nav nav-pills" id="pills-tab" role="tablist">
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link comment active" id="pills-home-tab" data-toggle="pill"
                                            href="#pills-home1" role="tab" aria-controls="pills-home"
                                            aria-selected="true">
                                            <i class="fa fa-comment"></i> Commentaires</a>
                                    </li>
                                    <li class="nav-item" role="presentation">
                                        <a class="nav-link comment" id="pills-profile-tab" data-toggle="pill"
                                            href="#pills-profile1" role="tab" aria-controls="pills-profile"
                                            aria-selected="false">
                                            <i class="fa fa-rss"></i> Suivis</a>
                                    </li>
                                    <li v-if="project.name != 'Aukohi Chap Chap' && project.name !=
                                    'Les latrines et les blocs sanitaires à usage scolaire' &&
                                    project.name !=
                                    'Lumière à Akêkoi' &&
                                    project.name != 'K’RINE MODE & CREATION' &&
                                    project.name !=
                                    'PLAYTIME'" class="nav-item" role="presentation">
                                        <a class="nav-link comment" id="pills-contact-tab" data-toggle="pill"
                                            href="#pills-contact1" role="tab" aria-controls="pills-contact"
                                            aria-selected="false">
                                            <i class="fa fa-users"></i> Contributeurs</a>
                                    </li>
                                </ul>
                            </div>
                            <div class="tab-content" id="pills-tabContent">
                                <div class="tab-pane fade show active" id="pills-home1" role="tabpanel"
                                    aria-labelledby="pills-home-tab">
                                    <div class="project-details-content-top">
                                        <div class="message mt-5">
                                            <div v-for="item in project.commentaire.slice(0, 3)"
                                                :key="item.commentaire.id" class="mb-1">
                                                <div class="row p-2 mb-1 comment-one__content">
                                                    <div class="col-8 col-md-10">
                                                        <h5 class="pb-2">{{ item.user != null ? item.user : 'Juris' }}
                                                            <span class="comment-one__date text-primary"> {{new Date(item.commentaire.created_at).toISOString().substr(0, 10)}}</span>
                                                        </h5>
                                                        {{ item.commentaire.message }}
                                                    </div>
                                                    <div v-if="this.oukanaute && userData != null"
                                                        class="col-4 col-md-2">
                                                        <span v-if="comment != item.commentaire.id" @click="comment = item.commentaire.id"
                                                            class="text-right text-info pt-4 text-danger"
                                                            style="cursor: pointer; color: red; font-size: 12px;">Répondre</span>
                                                        <span v-if="comment == item.commentaire.id" style="color: red; font-size: 12px;">Saisir le message dans le champs de saisir</span>
                                                    </div>
                                                </div>
                                                <div class="row mx-5">
                                                    <div v-for="(item1, index) in item.reply" :key="item1.id" class="col-12">
                                                        <div v-if="item.commentaire.id == item1.comment_id"
                                                            class="p-2 my-1 comment-two__content">
                                                            <div class="accordion accordion-flush" id="accordionFlushExample">
                                                                <div class="accordion-item">
                                                                    <h2 class="accordion-header border border-warning" id="flush-headingOne">
                                                                        <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapseOne' + index" aria-expanded="false" :aria-controls="'flush-collapseOne' + index">Porteur du projet <span
                                                                    class="comment-one__date text-primary ml-2"> {{new Date(item1.created_at).toISOString().substr(0, 10)}}</span></button>
                                                                    </h2>
                                                                    <div :id="'flush-collapseOne' + index" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                                        <div class="accordion-body">{{ item1.message }} </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div class="form-group mt-5">
                                            <textarea v-model="message" cols="30" rows="5"
                                                class="form-control"></textarea>
                                        </div>
                                        <!-- <div class="g-recaptcha" data-sitekey="6LehviAoAAAAABgFR4c6xTwJ9GnletcB64AO59wO"></div> -->
                                        <VueRecaptcha
                                            sitekey="6LfiLzkoAAAAAFGoI1EH-zhRmN9648CW11Kuemzr"
                                            :load-recaptcha-script="true"
                                            ref="recaptcha"
                                            type="invisible"
                                            @verify="handleSuccess"
                                            @error="handleError"
                                        ></VueRecaptcha>
                                        <div class="input-box">
                                            <button @click="sendMessage(project.id)"
                                                class="main-btn btn-sm">Envoyer</button>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-profile1" role="tabpanel"
                                    aria-labelledby="pills-profile-tab">
                                    <div class="project-details-content-top">
                                        <div class="message mt-5">
                                            <div v-for="(item, index) in project.news.slice(0, 3)" :key="item.id" class="mb-1">
                                                <div class="p-2">
                                                    <div class="accordion accordion-flush" id="accordionFlushExample">
                                                        <div class="accordion-item">
                                                            <h2 class="accordion-header border border-warning" id="flush-headingOne">
                                                                <button class="accordion-button collapsed" type="button" data-bs-toggle="collapse" :data-bs-target="'#flush-collapseOne' + index" aria-expanded="false" :aria-controls="'flush-collapseOne' + index">Porteur du projet <span
                                                            class="comment-one__date text-primary ml-2"> {{new Date(item.created_at).toISOString().substr(0, 10)}}</span></button>
                                                            </h2>
                                                            <div :id="'flush-collapseOne' + index" class="accordion-collapse collapse" aria-labelledby="flush-headingOne" data-bs-parent="#accordionFlushExample">
                                                                <div class="accordion-body">
                                                                    <img @click="showImg(item.image.src)"
                                                                    v-if="item.image != null"
                                                                    :src="item.image.src" alt="img" draggable="false"
                                                                    width="150" height="300" /> {{ item.message }} 
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                                <div class="tab-pane fade" id="pills-contact1" role="tabpanel" aria-labelledby="pills-contact-tab">
                                    <div class="project-details-content-top mt-3">
                                        <div class="row">
                                            <div v-for="(item, index) in project.contributeur" :key="item.id" class="col-md-3 p-2 border border-warning mx-1">
                                                <h5>{{ item.contributeur.anonyme == 1 ? 'Anonyme' : item.user.name }}</h5>
                                                <span>Montant du don: {{ item.contributeur.amount }} FCFA</span>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <!--====== PROJECT CONTENT PART ENDS ======-->
        </div>
        <div v-else class="loader"></div>
    </div>
</template>

<script>
import axios from 'axios';
import store from '../store';
import { VueRecaptcha } from 'vue-recaptcha';
import VueQrcode from '@chenfengyuan/vue-qrcode';

import QRCodeVue3 from "qrcode-vue3";
import QRCodeStyling from "qr-code-styling";

export default {
    components: {
        VueRecaptcha, 
        VueQrcode,

        QRCodeVue3, 
        QRCodeStyling, 
    },
    data() {
        return {
            api_url: String,
            url: String,
            project: null,
            slug: String,
            message: '',
            oukanaute: false,
            comment: 0,
            visible: false,
            index: 0,
            img: [],
            captcha: '',
            load: false,
        }
    },

    computed: {
        userData: () => store.getters.getUserData,
    },

    created() {
        this.api_url = process.env.VUE_APP_URL;
        this.getProjet();
    },

    methods: {
        downloadQrCode () {
            this.qrCode = new QRCodeStyling({
                width: 200,
                height: 200,
                data: this.url,
                image: '/assets/images/icon.png',
                qrOptions:{ 
                    typeNumber: 0, 
                    mode: 'Byte', 
                    errorCorrectionLevel: 'Q' 
                },
                dotsOptions: {
                    type: 'square',
                    color: '#26249a',
                    gradient: {
                        type: 'radial',
                        rotation: 0,
                        colorStops: [
                            { offset: 0, color: '#26249a' },
                            { offset: 1, color: '#26249a' },
                        ],
                    },
                },
                fileExt: "png",
            });
            this.qrCode.download({ name: this.project.name });
        },
        
        getProjet() {
            this.load = true;
            axios.get(this.api_url + 'project/' + this.slug)
                .then(async res => {
                    const collect = await res.data;
                    this.load = false;
                    if (collect.success)
                        this.project = collect.data;
                })
                .catch(err => console.log(err));
        },

        compareName(a, b) {
            let comparison = 0;
            if (a.amount > b.amount) comparison = 1;
            else if (a.amount < b.amount) comparison = -1;
            console.log(comparison);
            return comparison;
        },

        vote(project_id) {
            if (store.getters.getUserData != null) {
                axios.get(this.api_url + 'like/' + project_id, {
                    headers: {
                        'Authorization': 'Bearer ' + store.getters.getUserData.token
                    }
                })
                .then(res => {
                    const collect = res.data;
                    if (collect.success)
                        this.emitter.emit('event', { 'message': 'Vous avez voté pour ce projet', 'color': 'info' });
                    else
                        this.emitter.emit('event', { 'message': 'Vous avez déjà voté pour ce projet', 'color': 'error' });
                })
                .catch(err => console.log(err));
            }
            else this.emitter.emit('event', { 'message': 'Veuillez vous connecté pour poursuivre ...', 'color': 'info' });
        },

        sendMessage(project_id) {
            if (this.oukanaute == true && store.getters.getUserData != null && this.comment == 0)
                this.emitter.emit('event', { 'message': 'Veuillez cliqué sur répondre avant de laisser un message', 'color': 'error' });
            else {
                axios.post(this.api_url + 'comment', {
                    message: this.message,
                    project_id: project_id,
                    viewer: this.oukanaute == true && store.getters.getUserData != null ? 'holder'
                        : this.oukanaute == true && store.getters.getUserData == null ? 0
                            : store.getters.getUserData != null ? store.getters.getUserData.id : 'other',
                    comment: this.comment,
                    captcha: this.captcha,
                })
                    .then(res => {
                        const collect = res.data;
                        if (collect.success) {
                            this.emitter.emit('event', { 'message': collect.message, 'color': 'success' });
                            this.message = '';
                            this.getProjet();
                            this.handleError();
                        }
                    })
                    .catch(err => {
                        const collect = err.response.data;
                        this.handleError();
                        if (collect.message.errorBag == "default") {
                            this.emitter.emit('event', { 'message': 'Veuillez cocher Google recaptcha', 'color': process.env.VUE_APP_ERROR });
                            return;
                        }
                        else if (collect.errors)
                            this.emitter.emit('event', { 'message': collect.errors[Object.keys(collect.errors)[0]], 'color': process.env.VUE_APP_ERROR });
                        else if (collect.success == false)
                            this.emitter.emit('event', { 'message': collect.message, 'color': process.env.VUE_APP_ERROR });
                        else
                            this.emitter.emit('event', { 'message': 'Erreur de connexion', 'color': process.env.VUE_APP_ERROR });
                    });
            }

        },

        checkConnect(slug, id) {
            if (this.project.etat != 'Clôturé et réussi' && this.project.etat != 'Clôturé et échoué' && this.project.etat != 'Enregistré' && this.project.campagne_type != 'Vote') {
                if (store.getters.getUserData != null)
                    this.$router.push(`/contribution/${slug}/contrepartie/${id}`);
                else
                    this.emitter.emit('event', { 'message': 'Veuillez vous connecté pour poursuivre ...', 'color': 'info' });
            }
        },

        showImg(img) {
            this.visible = true;
            this.img = img;
        },

        handleSuccess(res) {
            this.captcha = res;
        },

        handleError() {
            this.$refs.recaptcha.reset();
        }
    },

    watch: {
        $route: {
            immediate: true,
            handler(to) {
                this.url = process.env.VUE_APP_COPY1 + to.path;
                if (to.name == 'viewer') this.oukanaute = true;
                else this.oukanaute = false;
                this.slug = to.params.id;
            }
        },
    }
}
</script>

<style scoped="this api replaced by slot-scope in 2.5.0+">

.fa-download {
    position: absolute;
    bottom: 0;
    margin: 10px;
    color: orange;
}

.qrcode {
  display: inline-block;
  font-size: 0;
  margin-bottom: 0;
  position: relative;
}

.qrcode__image {
  background-color: #fff;
  border: 0.25rem solid #fff;
  border-radius: 0.25rem;
  box-shadow: 0 0.125rem 0.25rem rgba(0, 0, 0, 0.25);
  left: 50%;
  overflow: hidden;
  position: absolute;
  top: 50%;
  transform: translate(-50%, -50%);
  width: 15%;
  height: 15%;
}

.project-details-content-area .project-details-content-top p {
    padding: 5px !important;
}

.project-details-content-area .tab-btns .nav li a {
    padding: 5px !important;
    font-size: 17px;
}

.page-title-area .page-title-content::before {
    display: none !important;
}

.jumbotron {
    padding: 1rem 1rem;
}

.project-details-content-area .tab-btns .nav li a.comment {
    padding: 15px !important;
    font-size: 17px;
    width: 200px;
    text-align: center;
}

.comment-one__single {
    padding-bottom: 10px;
}

.progress-bar {
    background-color: var(--yellow) !important;
}

.comment-one__content {
    background-color: #E4EBEA;
    word-break: break-all;
}

.comment-two__content {
    /* background-color: #e69a28; */
    word-break: break-all;
}

.overlay-dark {
    background-color: var(--yellow) !important;
    opacity: 0.4;
    z-index: 2;
}

.main-btn,
.nav-link {
    background-color: var(--yellow) !important;
}

.nav-link.active {
    background-color: #fff !important;
}

.project-details-area .project-details-content .project-details-item .item .title,
.project-details-area .project-details-content .projects-goal span span {
    color: orange !important;
}

.page-title-area .page-title-content::before {
    background-color: var(--yellow) !important;
}

.project-details-content-area .tab-btns .nav li a {
    line-height: 32px !important;
}

p {
    color: #000 !important;
}

@media screen and (max-width: 960px) {
    iframe {
        width: 100%;
        height: 200px;
    }

    .bg_cover {
        width: 100%;
        height: 300px;
    }

    .overlay-div {
        height: 52%;
    }

    .page-title-area .page-title-content {
        height: 100%;
        padding-top: 30px;
    }

    .img-fluid {
        width: 100px;
    }

    .project-details-area {
        padding-top: 25px !important;
    }
}

/* Accordion */
.accordion-button{position:relative;display:flex;align-items:center;width:100%;padding:1rem 1.25rem;font-size:1rem;color:#212529;text-align:left;background-color:#fff;border:0;border-radius:0;overflow-anchor:none;transition:color .15s ease-in-out,background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out,border-radius .15s ease}@media (prefers-reduced-motion:reduce){.accordion-button{transition:none}}.accordion-button:not(.collapsed){color:#0c63e4;background-color:#e7f1ff;box-shadow:inset 0 -1px 0 rgba(0,0,0,.125)}.accordion-button:not(.collapsed)::after{background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%230c63e4'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");transform:rotate(-180deg)}.accordion-button::after{flex-shrink:0;width:1.25rem;height:1.25rem;margin-left:auto;content:"";background-image:url("data:image/svg+xml,%3csvg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 16 16' fill='%23212529'%3e%3cpath fill-rule='evenodd' d='M1.646 4.646a.5.5 0 0 1 .708 0L8 10.293l5.646-5.647a.5.5 0 0 1 .708.708l-6 6a.5.5 0 0 1-.708 0l-6-6a.5.5 0 0 1 0-.708z'/%3e%3c/svg%3e");background-repeat:no-repeat;background-size:1.25rem;transition:transform .2s ease-in-out}@media (prefers-reduced-motion:reduce){.accordion-button::after{transition:none}}.accordion-button:hover{z-index:2}.accordion-button:focus{z-index:3;border-color:#86b7fe;outline:0;box-shadow:0 0 0 .25rem rgba(13,110,253,.25)}.accordion-header{margin-bottom:0}.accordion-item{background-color:#fff;border:1px solid rgba(0,0,0,.125)}.accordion-item:first-of-type{border-top-left-radius:.25rem;border-top-right-radius:.25rem}.accordion-item:first-of-type .accordion-button{border-top-left-radius:calc(.25rem - 1px);border-top-right-radius:calc(.25rem - 1px)}.accordion-item:not(:first-of-type){border-top:0}.accordion-item:last-of-type{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-item:last-of-type .accordion-button.collapsed{border-bottom-right-radius:calc(.25rem - 1px);border-bottom-left-radius:calc(.25rem - 1px)}.accordion-item:last-of-type .accordion-collapse{border-bottom-right-radius:.25rem;border-bottom-left-radius:.25rem}.accordion-body{padding:1rem 1.25rem}.accordion-flush .accordion-collapse{border-width:0}.accordion-flush .accordion-item{border-right:0;border-left:0;border-radius:0}.accordion-flush .accordion-item:first-child{border-top:0}.accordion-flush .accordion-item:last-child{border-bottom:0}.accordion-flush .accordion-item .accordion-button{border-radius:0}
</style>